// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* { margin: 0; padding: 0; box-sizing: border-box; }


.clover-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;
}

.clover-image {
    width: 100px;
    height: 100px;
    animation: scaleAndFade 0.5s infinite ease-in-out alternate;
    border-radius: 50%;
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.4);
}

@keyframes scaleAndFade {
    0% {
        transform: scale(1);
        opacity: 1;
    }
    100% {
        transform: scale(1.1);
        opacity: 0.8;
    }
}
/* 모바일 (세로 모드) - 여백 없음 */
@media (max-width: 576px) {
    .container {
        padding-top: 20vh; /* 상단 여백 추가 */
        padding-bottom: 5vh;
        overflow: hidden;
    }
}

/* 태블릿 - 여백 추가 */
@media (min-width: 577px) and (max-width: 992px) {
    .container {
        padding-top: 20vh; /* 상단, 하단 여백 */
        padding-bottom: 10vh;
    }
}

/* PC - 기본 설정 */
@media (min-width: 993px) {
    .container {
        padding-top: 20vh; /* 상단 여백 */
        padding-bottom: 10vh;
    }
}
`, "",{"version":3,"sources":["webpack://./src/component/lucky.css"],"names":[],"mappings":"AAAA,IAAI,SAAS,EAAE,UAAU,EAAE,sBAAsB,EAAE;;;AAGnD;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,2DAA2D;IAC3D,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;IACA;QACI,qBAAqB;QACrB,YAAY;IAChB;AACJ;AACA,wBAAwB;AACxB;IACI;QACI,iBAAiB,EAAE,aAAa;QAChC,mBAAmB;QACnB,gBAAgB;IACpB;AACJ;;AAEA,gBAAgB;AAChB;IACI;QACI,iBAAiB,EAAE,cAAc;QACjC,oBAAoB;IACxB;AACJ;;AAEA,eAAe;AACf;IACI;QACI,iBAAiB,EAAE,UAAU;QAC7B,oBAAoB;IACxB;AACJ","sourcesContent":["* { margin: 0; padding: 0; box-sizing: border-box; }\r\n\r\n\r\n.clover-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n}\r\n\r\n.clover-image {\r\n    width: 100px;\r\n    height: 100px;\r\n    animation: scaleAndFade 0.5s infinite ease-in-out alternate;\r\n    border-radius: 50%;\r\n    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n@keyframes scaleAndFade {\r\n    0% {\r\n        transform: scale(1);\r\n        opacity: 1;\r\n    }\r\n    100% {\r\n        transform: scale(1.1);\r\n        opacity: 0.8;\r\n    }\r\n}\r\n/* 모바일 (세로 모드) - 여백 없음 */\r\n@media (max-width: 576px) {\r\n    .container {\r\n        padding-top: 20vh; /* 상단 여백 추가 */\r\n        padding-bottom: 5vh;\r\n        overflow: hidden;\r\n    }\r\n}\r\n\r\n/* 태블릿 - 여백 추가 */\r\n@media (min-width: 577px) and (max-width: 992px) {\r\n    .container {\r\n        padding-top: 20vh; /* 상단, 하단 여백 */\r\n        padding-bottom: 10vh;\r\n    }\r\n}\r\n\r\n/* PC - 기본 설정 */\r\n@media (min-width: 993px) {\r\n    .container {\r\n        padding-top: 20vh; /* 상단 여백 */\r\n        padding-bottom: 10vh;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
